import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { auth } from '../../../config/Fire';
import { setLogout } from '../../../actions/user';
import { getUser, getCompanies } from '../../../reducers';
import * as Constants from '../../../constants';
import MainMenuAdmin from '../../components/MainMenuAdmin';
import SurveysStatistics from '../Surveys/SurveysStatistics';
import SurveysUsers from '../Surveys/SurveysUsers';
import SurveysTemplates from '../Surveys/SurveysTemplates';
import Inventory from '../Inventory'
import NewVehicle from '../Inventory/NewVehicle'
import EditVehicle from '../Inventory/EditVehicle'
import NewTool from '../Inventory/NewTool'
import EditTool from '../Inventory/EditTool'
import Users from '../Users';

import { getAllCompanies } from '../../../actions/company/getAllCompanies';
import LoadingPage from '../../components/LoadingPage';
import InventoryHistorical from '../../client/InventoryHistorical'

const { Content, Footer } = Layout;

class MainAdmin extends Component {
    state = {
        itemSelected: Constants.MenuAdmin.USERS
    }

    onItemClick = ({itemClickType}) => {
        switch (itemClickType) {
            case Constants.MenuAdmin.USERS:
                this.props.history.push(`/`);
                break;
            case Constants.MenuAdmin.LOGOUT:
                this.props.setLogout();
                auth.signOut();
                this.props.history.push(`/`);
                break;
            default:
                this.props.history.push(`/${itemClickType}`);
                break;
        }
        this.setState({ itemSelected: itemClickType });
    }

    handlerGetInfo = () => {
        this.props.getAllCompanies()
        return <LoadingPage />
    }

    render() {
        const { location, companies, user } = this.props;
        return (
            <Layout style={{ minHeight: '100vh' }}>
                {
                    companies ?
                        <div>
                            <MainMenuAdmin onItemClick={this.onItemClick} itemSelected={location.pathname}/>
                            <Layout>
                                <Content style={{ margin: '0' }}>
                                    <div style={{ margin: '0', padding: 16, background: '#fff', minHeight: '90vh' }}>
                                        <Route  exact path={`/${Constants.MenuAdmin.INVENTORY_HISTORICAL}`} component={ InventoryHistorical } />
                                        <Route exact path={`/${Constants.MenuAdmin.SURVEYS.STATISTICS}`} component={ SurveysStatistics }/>
                                        <Route exact path={`/${Constants.MenuAdmin.SURVEYS.SURVEYS_USERS}`} component={ SurveysUsers }/>
                                        <Route exact path={`/${Constants.MenuAdmin.SURVEYS.TEMPLATES}`} component={ SurveysTemplates }/>
                                        <Route exact path={`/${Constants.MenuAdmin.INVENTORY.HOME}`} component={ Inventory }/>
                                        <Route exact path={`/${Constants.MenuAdmin.INVENTORY.NEW_VEHICLE}`} component={ NewVehicle }/>
                                        <Route path={`/${Constants.MenuAdmin.INVENTORY.EDIT_VEHICLE}`} component={ EditVehicle }/>
                                        <Route exact path={`/${Constants.MenuAdmin.INVENTORY.NEW_TOOL}`} component={ NewTool }/>
                                        <Route path={`/${Constants.MenuAdmin.INVENTORY.EDIT_TOOL}`} component={ EditTool }/>
                                        <Route exact path="/" component={ Users } />
                                    </div>
                                </Content>
                                <Footer style={{ textAlign: 'center' }}>
                                    Copyright ©2020 <a href="https://www.autosolve.com.ar/" target="_blank" rel="noopener noreferrer">AutoSolve</a>
                                </Footer>
                            </Layout>
                        </div>
                        :
                        this.handlerGetInfo()
                }
            </Layout>
        );
    }
}

MainAdmin.propTypes = {
    setLogout: PropTypes.func.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setLogout: value => dispatch(setLogout(value)),
    getAllCompanies: value => dispatch(getAllCompanies(value)),
});

const mapStateToProps = state => ({
    user:  getUser(state),
    companies:  getCompanies(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(MainAdmin));
